import { Attributes, DateUtils, Misc, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class IssuerInvestmentTermsAcceptedDate extends TemporalEntity {
    static typeName = "IssuerInvestmentTermsAcceptedDate";

    constructor() {
        super();
        this.makeObservable();
    }

    public issuerInvestmentTermsAcceptedDateId: number = 0;

    public issuerInvestmentId: number = 0;

    @Rules.Required()
    public investorReferralTypeId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public termsAcceptedDate: Date = DateUtils.today();

    @Rules.Required()
    @Rules.StringLength(100)
    @Rules.EmailAddress()
    public emailAddress: string = "";

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<IssuerInvestmentTermsAcceptedDate>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.emailAddress) {
            return "New issuer investment terms accepted date";
        } else {
            return this.emailAddress;
        }
    }
}